export default "__VITE_ASSET__ZYuHO$_i__"